<script setup lang="ts">
import { cn } from "@client/lib/utils";
import { ToastRoot, type ToastRootEmits, useForwardPropsEmits } from "reka-ui";
import { computed } from "vue";
import { type ToastProps, toastVariants } from ".";

const props = defineProps<ToastProps>();

const emits = defineEmits<ToastRootEmits>();

const delegatedProps = computed(() => {
	const { class: _, ...delegated } = props;

	return delegated;
});

const forwarded = useForwardPropsEmits(delegatedProps, emits);
</script>

<template>
	<ToastRoot
		class="ToastRoot"
		v-bind="forwarded"
		:class="cn(toastVariants({ variant }), props.class)"
		@update:open="onOpenChange">
		<slot />
	</ToastRoot>
</template>
<style>
.ToastRoot[data-swipe="end"] {
	animation: ToastSlideLeft 100ms ease-out;
}
/* data-[state=closed]:t-slide-out-to-right-full */
.ToastRoot[data-state="closed"] {
	animation: ToastSlideLeft 100ms ease-out;
}

@keyframes ToastSlideLeft {
	from {
		transform: translateX(var(--radix-toast-swipe-end-x));
	}
	to {
		transform: translateX(-100%);
	}
}
</style>
